import { render, staticRenderFns } from "./UserDependentTextList.vue?vue&type=template&id=bda56a9c&"
import script from "./UserDependentTextList.vue?vue&type=script&lang=js&"
export * from "./UserDependentTextList.vue?vue&type=script&lang=js&"
import style0 from "./UserDependentTextList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports